import cytoscape from 'cytoscape'
import compoundDragAndDrop from 'cytoscape-compound-drag-and-drop'
import coseBilkent from 'cytoscape-cose-bilkent'
import fcose from 'cytoscape-fcose'
import svg from 'cytoscape-svg'

cytoscape.use(compoundDragAndDrop)
cytoscape.use(coseBilkent)
cytoscape.use(fcose)
cytoscape.use(svg)

export default cytoscape
